import { Box, CircularProgress } from "@material-ui/core";
import React from "react";

const PageLoading = () => {
  return (
    <Box
      width="100vw"
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress color="primary" />
    </Box>
  );
};

export default PageLoading;
